import React from 'react';
import { useBrandSettings } from '../contexts/BrandSettingsContext';
import { Shield } from 'lucide-react';

const BrandLogo = ({ width = 140, height = 40, variant = 'default', className = '' }) => {
  const { brandName, logoUrl, header } = useBrandSettings();

  // Determine which logo to use based on variant
  const getLogoUrl = () => {
    switch (variant) {
      case 'light':
        return header?.logoLight || logoUrl;
      case 'transparent':
        return header?.logoTransparent || logoUrl;
      case 'sticky':
        return header?.logoSticky || logoUrl;
      case 'mobile':
        return header?.logoMobile || logoUrl;
      default:
        return header?.logoDefault || logoUrl;
    }
  };

  const currentLogo = getLogoUrl();

  if (currentLogo) {
    return (
      <img 
        src={currentLogo} 
        alt={brandName} 
        style={{ width, height: 'auto', maxHeight: height }}
        className={className}
      />
    );
  }

  // Text-based logo using CMS brand name - no fallback
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <div className="flex items-center justify-center w-8 h-8 bg-primary rounded-lg">
        <Shield className="w-5 h-5 text-white" />
      </div>
      <span
        className="font-bold text-xl tracking-tight"
        style={{ color: variant === 'light' ? '#ffffff' : 'var(--color-primary)' }}
      >
        {brandName}
      </span>
    </div>
  );
};

export default BrandLogo;
